const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const CONTRACT = 'self_service_registration_v1';
const ACTIONS = new Set(['verify_email', 'accept_terms', 'create_company', 'welcome', 'accept_invitation', 'registration_unavailable']);

// Only a server-authenticated no-membership response may enter this helper.
// An unavailable policy or a wrong-company denial must remain in the app guard.
export async function registrationHandoff({ error, hash = '', request } = {}) {
  if (error?.code !== 'no_company_membership' || Number(error.status) !== 403) return null;
  const fragment = String(hash).replace(/^#\/?/, '');
  const [route, query = ''] = fragment.split('?');
  const params = new URLSearchParams(query);
  const invitationId = route === 'accept-invite' && params.getAll('invitation').length === 1
    && UUID.test(params.get('invitation') || '') ? params.get('invitation') : null;
  if (route === 'accept-invite' && !invitationId) return null;
  try {
    const config = await request('/api/saas/registration/config');
    if (config?.enabled !== true || config.contractVersion !== CONTRACT) return null;
    const intent = invitationId ? 'invite' : 'create_company';
    const input = new URLSearchParams({ intent });
    if (invitationId) input.set('invitationId', invitationId);
    const state = await request(`/api/saas/registration/state?${input}`);
    if (state?.contractVersion !== CONTRACT || !UUID.test(state.user?.id || '') || !ACTIONS.has(state.nextAction)) return null;
    const target = new URLSearchParams({ intent });
    if (invitationId) target.set('invitation', invitationId);
    return invitationId ? `/login?${target}` : '/signup';
  } catch {
    return null;
  }
}
